export const contactDetails = {
    address: '115 KM3 Marcos Highway, Bakakeng Central, Baguio City',
    phone: '(074) 446 6593',
    mobile: '+63 923 135 6990',
    email: 'vignorthbuilders@gmail.com',
    facebook: 'facebook.com/vignorthbuilders',
    instagram: 'instagram.com/vignorthbuilders',
};